import { formatCryptoBalance, formatUSDBalance } from '../../../utils/formatBalance';
import { useSelector, useDispatch } from 'react-redux';
import { syncWallet } from '../../../redux/slices/walletSlice';
import { RefreshCw } from 'lucide-react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';

const CoinStats = ({ coin }) => {
  const dispatch = useDispatch();
  const mode = useSelector(state => state.mode.mode);
  const { syncStatus, lastSyncAt } = useSelector(state => state.wallet);

  if (!coin) return null;

  const usdValue = coin.price?.price ? coin.balance * coin.price.price : 0;

  return (
    <div className="row mb-4">
      <div className="col-md-6 mb-md-0 mb-3">
        <div className="card p-3 mb:mb-3 m-0">
          <div className="flex justify-between items-center">
            <span>Your Balance</span>
            {mode === 'private' && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="sync-tooltip">Sync Wallet {lastSyncAt ? `(Last: ${moment(lastSyncAt).format('HH:mm:ss')})` : ''}</Tooltip>}
              >
                <button
                  className="btn-icon p-1"
                  onClick={() => dispatch(syncWallet(mode))}
                  disabled={syncStatus === 'syncing'}
                >
                  <RefreshCw className={`w-4 h-4 text-primary ${syncStatus === 'syncing' ? 'refresh-rotating' : ''}`} />
                </button>
              </OverlayTrigger>
            )}
          </div>
          <h3 className="font-semibold text-2xl mb-0 mt-1">
            {formatCryptoBalance(coin.balance, coin.symbol)}
          </h3>
        </div>
      </div>

      <div className="col-md-6">
        <div className="card p-3 mb:mb-3 m-0">
          <span>USD Value</span>
          <h3 className="font-semibold text-2xl mb-0 mt-1">
            {coin.price?.price ? formatUSDBalance(usdValue) : 'N/A'}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default CoinStats;